import React, { useEffect, useRef } from 'react';
import { ShieldCheck, Globe, Lock, CheckCircle } from 'lucide-react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Styling/TrustStatement.css';

gsap.registerPlugin(ScrollTrigger);

const TrustStatement = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(".Trust-Main-Card", {
                scrollTrigger: {
                    trigger: ".Trust-Main-Card",
                    start: "top 90%",
                },
                y: 50,
                opacity: 0,
                scale: 0.98,
                duration: 1.5,
                ease: "power3.out"
            });

            gsap.from(".Trust-Item-Badge", {
                scrollTrigger: {
                    trigger: ".Trust-Grid",
                    start: "top 95%",
                },
                y: 30,
                opacity: 0,
                scale: 0.9,
                duration: 1,
                stagger: 0.1,
                ease: "back.out(1.7)"
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section className="Global-Trust-Framework" ref={sectionRef}>
            <div className="container">
                <div className="Trust-Main-Card">
                    <div className="Trust-Header-Icon">
                        <ShieldCheck size={48} />
                    </div>

                    <h2 className="Trust-Title">Global Trust & Operations</h2>

                    <div className="Trust-Content-Wrapper">
                        <p className="Trust-Description">
                            Digital Dream Works builds high-performance systems integrated into real-world operations across logistics,
                            enterprise teams, and growth-focused organizations. Our infrastructure is built for reliability,
                            security, and measurable impact.
                        </p>

                        <div className="Trust-Grid">
                            <div className="Trust-Item-Badge">
                                <Lock size={18} />
                                <span>No Free Trials</span>
                            </div>
                            <div className="Trust-Item-Badge">
                                <Globe size={18} />
                                <span>No Generic Templates</span>
                            </div>
                            <div className="Trust-Item-Badge">
                                <CheckCircle size={18} />
                                <span>No Experimental Deploys</span>
                            </div>
                        </div>

                        <div className="Trust-Statement-Footer">
                            Access to systems is provided exclusively through controlled demos and commercial agreements.
                            We prioritize production-grade stability over experimental exploration.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustStatement;
